/* eslint-disable */

var UISettings = require('./utils/UISettings.js');
var StoreAvailability = require('./storeavailability').StoreAvailability;

var dayjs = require('dayjs');
var customParseFormat = require('dayjs/plugin/advancedFormat');

dayjs.extend(customParseFormat);


/** @see {@link http://confluence.dixons.co.uk/display/DBS/Final} */
/** @constructor */
/** @param {object} data */
/** @param {string} location */
function ProductAvailability(data, location){
    this.__data = data;
    this.__location = location;
}
ProductAvailability.prototype = {
    __availableStores : null,

    /** @returns {boolean} */
    isStockCheckEnabled : function(){
        return this.__data.configuration && this.__data.configuration.stockCheckerEnabled || false;
    },

    /** @returns {boolean} */
    isDeliveryCheckEnabled : function(){
        return this.__data.configuration && this.__data.configuration.deliverySlots || false;
    },

    /** @returns {boolean} */
    isDeliveryStepEnabled : function(){
        return this.__data.configuration && this.__data.configuration.deliverySlotsSafetyStep && this.isDeliveryCheckEnabled() ? true : false;
    },

    /** @returns {boolean} */
    isPayAndCollectFromStoreStockEnabled : function(){
        return this.__data.configuration && this.__data.configuration.payAndCollectFromStoreStock || false;
    },

    /** @returns {boolean} */
    hasDeliverySlots : function(){
        // Equates to this.__data.configuration.deliverySlotsSafetyStep === true || false and contains delivery data
        return (this.__data.deliveryTable && this.__data.deliveryTable.deliveryTable && this.__data.deliveryTable.deliveryTable.length > 0) ? true : false;
    },

    /** @returns {string or null} */
    getFreeDeliverySoonestDateFromDeliverySlots : function() {
      if (this.__data.deliveryTable && this.__data.deliveryTable.deliveryTable && this.__data.deliveryTable.deliveryTable.length > 0) {
        var deliveryItemWithFreeSlot = this.__data.deliveryTable.deliveryTable.find(
          deliveryItem => deliveryItem.deliverySlots && (deliveryItem.deliverySlots.findIndex(slot => slot.price === 'Free') !== -1 )
          );

        if (deliveryItemWithFreeSlot) {
          return deliveryItemWithFreeSlot.deliverySlots.find(slot => slot.price === 'Free').date;
        }

        return null;
      }

      return null;
    },

    /** @returns {string or null} */
    getEarliestDeliveryDateString : function() {
        if (this.__data.deliveryTable && this.__data.deliveryTable.deliveryTable && this.__data.deliveryTable.deliveryTable.length > 0) {
            const firstDate = dayjs(new Date(this.__data.deliveryTable.deliveryTable[0].deliverySlots[0].date));
            const nextDate = dayjs(new Date(
              this.__data.deliveryTable.deliveryTable[0].deliverySlots[1]
                ? this.__data.deliveryTable.deliveryTable[0].deliverySlots[1].date
                : '9999/09/09'
            ));
            const earliestDate = firstDate.isBefore(nextDate) ? firstDate : nextDate;
            return earliestDate.format('Do MMM');
        }
        return null;
    },

    /** @returns {string or null} */
    getPriceStringOfCheapestSlot: function() {
      if (this.__data.deliveryTable && this.__data.deliveryTable.deliveryTable && this.__data.deliveryTable.deliveryTable.length > 0) {
        if (this.getProductType() === 'SMALLBOX' || this.getFreeDeliverySoonestDateFromDeliverySlots()) {
          return 'FREE';
        }

        var prices = [];

        this.__data.deliveryTable.deliveryTable.forEach((deliveryItem) => {
          deliveryItem.deliverySlots.forEach((slot) => {
            prices.push(slot.price);
          })
        });


        prices.sort((a,b) => Number(a.slice(1)) - Number(b.slice(1)));

        return prices[0];
      }

      return null;
    },
    isNextDayDeliveryAvailable: function() {
      const tomorrowDate = dayjs().add(1, 'day');
      const tomorrowDateString = tomorrowDate.format('YYYY/MM/DD');

      if (this.__data.deliveryTable && this.__data.deliveryTable.deliveryTable && this.__data.deliveryTable.deliveryTable.length > 0) {
        return this.__data.deliveryTable.deliveryTable.findIndex(deliveryItem => deliveryItem.deliverySlots[0].date === tomorrowDateString) !== -1;
      }

      return false
    },
    /** @returns {boolean} */
    isDeliverable : function(){
        return this.getDeliveryState() === "DELIVERABLE" ? true : false;
    },

    /** @returns {boolean} */
    isUnDeliverable : function(){
        return this.getDeliveryState() === "UNDELIVERABLE" ? true : false;
    },

    /** @returns {boolean} */
    isUndeliverablePostcode : function(){
        return this.getDeliveryState() === "UNDELIVERABLE_POSTCODE" || this.isUndeliverablePostcodeSmallBox() || this.isUndeliverablePostcodeBigBox() ? true : false;
    },

    /** @returns {boolean} */
    isUndeliverablePostcodeSmallBox : function(){
        return this.getDeliveryState() === "UNDELIVERABLE_POSTCODE_SMALLBOX" ? true : false;
    },

    /** @returns {boolean} */
    isUndeliverablePostcodeBigBox : function(){
        return this.getDeliveryState() === "UNDELIVERABLE_POSTCODE_BIGBOX" ? true : false;
    },

    /** @returns {string} */
    getLocation : function(){
        return this.__location;
    },

    /** @returns {string} */
    getDeliveryLabel : function(){
        return this.__data.postCodeCheck && this.__data.postCodeCheck.label || "";
    },

    /** @returns {string} */
    getDeliveryState : function(){
        return this.__data.postCodeCheck && this.__data.postCodeCheck.state || "";
    },

    /** @returns {boolean} */
    isCollectable : function(){
        return (this.getCollectionState() === "COLLECTABLE" && this.getAvailableStores().length > 0) ? true : false;
    },

    /** @returns {boolean} */
    isUncollectable : function(){
        return this.getCollectionState() === "UNCOLLECTABLE"  ? true : false;
    },

    /** @returns {boolean} */
    isUnCollectablePostcode : function(){
        return this.getCollectionState() === "UNCOLLECTABLE_POSTCODE" ? true : false;
    },

    /** @returns {boolean} */
    isUncollectableOutOfStock: function () {
        return this.getCollectionState() === 'UNCOLLECTABLE_OUT_OF_STOCK';
    },

    /** @returns {string} */
    getCollectionState : function(){
        return this.__data.postCodeCheck && this.__data.postCodeCheck.storeState || "";
    },

    /** @returns {string} */
    getCollectionLabel : function(){
        return this.__data.postCodeCheck && this.__data.postCodeCheck.storeLabel || "";
    },

    /** @returns {array<StoreAvailability>} */
    getAvailableStores : function(){
        if(!this.__availableStores && this.__data.collect){
            this.__availableStores = [];
            for(var i = 0; i < this.__data.collect.length; i++){
                this.__availableStores.push(new StoreAvailability(this.__data.collect[i]));
            }
        }
        return this.__availableStores || [];
    },

    /** @param {function(deliverySlots : array<object>)} onsuccess */
    /** @param {function(error : string)} onerror */
    /** @returns {void} */
    getProductDelivery : function(onsuccess, onerror){
        if(this.hasDeliverySlots()){
            onsuccess(this, this.__data.deliveryTable.deliveryTable);
        } else {
            if(!this.isDeliveryCheckEnabled()){
                onerror("Delivery Check Not Enabled");
                return;
            }
            var API = require('./api');
            var data = this.__data;
            var url;

            var xhrUrlData = {
                postcode: this.getLocation()
            };

            if(data.lastCoords && Object.keys(data.lastCoords).length === 2) {
                url = API.PRODUCT_DELIVERY_SLOTS_URL_WITH_COORDS;
                xhrUrlData.coords = [
                    data.lastCoords.latitude,
                    data.lastCoords.longitude
                ];
            } else {
                url = API.PRODUCT_DELIVERY_SLOTS_URL;
            }

            url = API.prepareXhrUrl(url, xhrUrlData);

            var self = this;
            $.ajax({
                url : url,
                cache : true,
                error : onerror,
                success : function(result){
                    try {
                        if(result.status === "success"){
                            data.deliveryTable = result.data.deliveryTable || [];
                            data.lastHomeDeliveryPostcode = result.data.lastHomeDeliveryPostcode;
                            data.showHomeDeliveryPostcodeInfo = result.data.showHomeDeliveryPostcodeInfo;
                            if(result.data.postCodeCheck){
                                data.postCodeCheck.state = result.data.postCodeCheck.state;
                                data.postCodeCheck.label = result.data.postCodeCheck.label;
                            }
                            if(result.data.postCodeCheckAnalytics){
                                data.postCodeCheckAnalytics = result.data.postCodeCheckAnalytics;
                            }
                            onsuccess(self, data.deliveryTable.deliveryTable || []);
                        } else {
                            onerror(result.message);
                        }
                    } catch (e) {
                        console.error(e);
                        onerror(e);
                    }
                }
            });
        }
    },

    /** @returns {string} */
    getProductType : function(){
        return this.__data.postCodeCheck && this.__data.postCodeCheck.productType || "";
    },

    /** @returns {string} */
    getProductSegment : function(){
        return UISettings.get('component.mcd.postcodechecker.segment');
    },

    /** @returns {string} */
    getAvailabilityInfo : function(){
        return this.__data.postCodeCheck && this.__data.postCodeCheck.info || "";
    },

    /** @returns {string} */
    getPreviousDeliveryLocation: function(){
        return this.__data.lastHomeDeliveryPostcode || "";
    },

    /** @returns {boolean} */
    isSplitDelivery: function(){
        return this.__data.showHomeDeliveryPostcodeInfo || false;
    },

    /** @returns {boolean} */
    isTradeplaceProduct: function(){
        return this.getProductType() === "TRADEPLACE" ? true : false;
    },

    /** @returns {object} */
    getAnalytics: function() {
        return this.__data.postCodeCheckAnalytics || {
            soonestDelivery: null,
            soonestFreeDelivery: null
        };
    }
};

module.exports = ProductAvailability;
